/**
 * Enumeration to list all possible states for an order
 */
export enum ShipmentStateEnum {
  UNKNOWN = -1,
  TO_SHIP = 0,
  PLANNED = 1,
  TO_COLLECT = 2,
  IN_TRANSIT = 3,
  DELIVERED = 4,
  CANCELLED = 5,
}
